import { Children, cloneElement, ReactElement } from "react";
import { useModal } from "../ModalRoot/ModalRoot";

interface ModalTriggerProps {
  children: ReactElement;
}

const ModalTrigger = ({ children }: ModalTriggerProps) => {
  const { setOpen } = useModal();
  return Children.map(children, (child) =>
    cloneElement(child, {
      onClick: () => {
        setOpen(true);
      },
    }),
  );
};

export default ModalTrigger;
